var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopYellowVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 511,
    viewBox: "0 0 751 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1231.09 2.11279L490.311 131.061C300.213 164.15 134.386 298.343 59.9741 495.983C5.11246 641.714 1.01458 841.535 2.07956 909.483",
    stroke: "#DFE33E",
    strokeWidth: 3.47222,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopYellowVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop_yellow_vector.8a9d1181152ed61fe3c76818edf04bad.svg";